const limitStringLength = (string: string, maxLength: number) =>
    string.length > maxLength ? string.substring(0, maxLength - 3).concat('...') : string;

export default limitStringLength;
